var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPieChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    fillOpacity: 0.01
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_975",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_975)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9167 10.9997H19.25C19.7563 10.9997 20.1667 10.5893 20.1667 10.083C20.1667 5.52666 16.473 1.83301 11.9167 1.83301C11.4104 1.83301 11 2.24341 11 2.74967V10.083C11 10.5893 11.4104 10.9997 11.9167 10.9997V10.9997Z",
    fill: "#e12728"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0391 11.9165H10.0833V2.96068C10.0902 2.67822 9.96653 2.40833 9.74801 2.22922C9.52949 2.0501 9.24058 1.98177 8.96497 2.04401C4.5548 3.06639 1.55144 7.15516 1.89486 11.6692C2.23828 16.1833 5.82563 19.7707 10.3397 20.1141C14.8538 20.4576 18.9426 17.4542 19.965 13.0441C20.0272 12.7684 19.9589 12.4795 19.7798 12.261C19.6007 12.0425 19.3308 11.9187 19.0483 11.9257L19.0391 11.9165Z",
    fill: "#e12728"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChart);
export default __webpack_public_path__ + "static/media/pie-chart.15c394ca1fc0b088e70f9c91cd3d6285.svg";
export { ForwardRef as ReactComponent };